import React from 'react';
import {utils} from '../../utils'

class BottomLink extends React.Component {
  constructor(props) {
    super(props);

  }

  render() {

    var curItem = this.props.current.item;

    var bottomLink = (curItem.hasLink && !utils.isMobile()) ? (
      curItem.linkType === 'web' ? (
        <a className={"fullscreen-bottom-link link"}
           href={curItem.linkUrl}
           target={curItem.linkOpenType}
           tabIndex={utils.getTabIndex('fullscreenLink')}
           aria-label={curItem.linkText}
        >
          {curItem.linkText ? curItem.linkText : curItem.linkUrl}
        </a>
      ) : (
        <a
          className={"fullscreen-bottom-link link"}
          onClick={() => this.props.actions.navigateToPageByItemLink(curItem)}
          tabIndex={utils.getTabIndex('fullscreenLink')}
          aria-label={curItem.linkText}
        >
          {curItem.linkText ? curItem.linkText : curItem.linkUrl}
        </a>
      )
    ) : false;

    var bottomLinkContainer = (!this.props.current.hasInfo && curItem.hasLink && !utils.isStoreGallery()) ? (
      <div className={"bottom-link"}>
        {bottomLink}
      </div>
    ) : false;

    return bottomLinkContainer;

  }
}

export default BottomLink;



// WEBPACK FOOTER //
// ./components/fullscreen/bottomLink.js